import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BoxGeometry, PlaneGeometry } from 'three';
import { maths } from '../../../utils';
import { useSRGBColors } from '../r3f-components/hooks/useSRGBColors';
const LineBox = ({ visible, rotation: [rx, ry, rz] = [0, 0, 0], position = [0, 0, 0], scale: [sx, sy, sz], enabled = true, color: c, lineWidth = 4, pointerDownHandler, pointerUpHandler, renderOrder, stopEventPropagation: stpEnvProp }) => {
    const geom = useMemo(() => {
        return !!sz ?
            new BoxGeometry(sx * 2, sy * 2, sz * 2) :
            new PlaneGeometry(sx * 2, sy * 2);
    }, [sx, sy, sz]);
    const geometry = useMemo(() => _jsx("edgesGeometry", { attach: "geometry", args: [geom] }), [geom]);
    const rotation = [maths.toRadians(rx), maths.toRadians(ry), maths.toRadians(rz)];
    const color = useSRGBColors(c);
    if (renderOrder === undefined)
        renderOrder = 999995;
    return (_jsx("group", { renderOrder: renderOrder, children: _jsx("mesh", { renderOrder: renderOrder, position: position, rotation: rotation, visible: visible, onPointerDown: (e) => {
                if (stpEnvProp)
                    e.stopPropagation();
                if (enabled && pointerDownHandler)
                    pointerDownHandler(e);
            }, onPointerUp: (e) => {
                if (stpEnvProp)
                    e.stopPropagation();
                if (enabled && pointerUpHandler)
                    pointerUpHandler(e);
            }, children: _jsxs("lineSegments", { children: [geometry, _jsx("lineBasicMaterial", { attach: "material", linewidth: lineWidth, opacity: c[3], color: color })] }) }) }));
};
export default LineBox;
